import { render, staticRenderFns } from "./editGovernmentSector.vue?vue&type=template&id=37663620&"
import script from "./editGovernmentSector.vue?vue&type=script&lang=js&"
export * from "./editGovernmentSector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports